import TreatabilityBanner from './TreatabilityBanner';

export default TreatabilityBanner;
